import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
import { getCategoryListByProfile } from "./../Myprofilepage/Myprofilepage.api";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import NavCard from "../Dashboard/NavCard";
import { FiArrowRight, FiCheckCircle } from "react-icons/fi";
import { PageHeader } from "components/ui";
import { useTranslation } from "react-i18next";
import { axiosClient } from "api/api";

function MyProfileComponents() {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const [langCode, setLangCode] = useState("");

  const getCategoryProfile = useQuery(
    ["myprofile"],
    () => getCategoryListByProfile(auth.panelistId, langCode),
    {
      enabled: !!langCode,
      refetchOnWindowFocus: false,
    }
  );

  const getData = async () => {
    const ipUrl = `/api/user/get-ip-details`;
    const res = await axiosClient.get(ipUrl, { timeout: 5000, });
    if (res.data.data.country.currency.code == "USD") {
      // setCountry("USA");
      setLangCode("En-US");
      localStorage.setItem("zamplia_user_lang_code", "En-US");
      localStorage.setItem("current_user_region", res.data.data.region_name);
      localStorage.setItem("current_user_postal", res.data.data.postal);
    } else if (res.data.data.country.currency.code == "CAD") {
      // setCountry("Canada");
      setLangCode("English-CA");
      localStorage.setItem("zamplia_user_lang_code", "English-CA");
      localStorage.setItem("current_user_region", res.data.data.region_name);
      localStorage.setItem("current_user_postal", res.data.data.postal);
    } else if (res.data.data.country.currency.code == "GBP") {
      // setCountry("UK");
      setLangCode("English-GB");
      localStorage.setItem("zamplia_user_lang_code", "English-GB");
      localStorage.setItem("current_user_region", res.data.data.region_name);
      localStorage.setItem("current_user_postal", res.data.data.postal);
    } else if (res.data.data.country.currency.code == "INR") {
      setLangCode("English-IN");
      localStorage.setItem("zamplia_user_lang_code", "English-IN");
      localStorage.setItem("current_user_region", res.data.data.region_name);
      localStorage.setItem("current_user_postal", res.data.data.postal);
    } else {
      // setCountry(res.data.data.currency.code);

      setLangCode(res.data.data.country_name + "-" + res.data.data.country.currency.code);
      localStorage.setItem(
        "zamplia_user_lang_code",
        res.data.data.country_name + "-" + res.data.data.country.currency.code
      );

      //this is testing data
      // localStorage.setItem("current_user_region", "New York");
      // localStorage.setItem("current_user_postal", "10014");
      // localStorage.setItem("zamplia_user_lang_code", "En-US");
      // setLangCode("En-US");
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const categories = getCategoryProfile?.data?.result;
  const getCompletion = (survey) =>
    Math.round(
      survey.totalQuestion !== 0 && survey.totalAttemptQuestion !== 0
        ? survey.totalAttemptQuestion > survey.totalQuestion
          ? (survey.totalQuestion / survey.totalQuestion) * 100
          : (survey.totalAttemptQuestion / survey.totalQuestion) * 100
        : 0
    );
  const completedCount = categories?.length > 0 ? categories.filter((s) => getCompletion(s) >= 100).length : 0;

  return (
    <div className="zs-page">
      <PageHeader
        eyebrow="Profile"
        title={t("my.profile.title")}
        subtitle={t("my.profile.response")}
        actions={
          categories?.length > 0 ? (
            <span className="zs-badge zs-badge-primary">
              <FiCheckCircle className="w-3.5 h-3.5" />
              {completedCount} / {categories.length} complete
            </span>
          ) : null
        }
      />

      <NavCard />

      <div className="flex items-center justify-between gap-3 mt-8 mb-4">
        <div>
          <h2 className="zs-section-title">Profile categories</h2>
          <p className="mt-0.5 text-sm text-ink-3">
            Complete each category so we can match you with surveys that fit you best.
          </p>
        </div>
      </div>

      {getCategoryProfile.isLoading && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" aria-busy="true">
          <span className="sr-only">{t("claim.card.Loading")}</span>
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="flex flex-col gap-3 p-5 zs-card">
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 zs-skeleton" />
                <div className="rounded-full w-14 h-14 zs-skeleton" />
              </div>
              <div className="w-2/3 h-4 zs-skeleton" />
              <div className="w-full h-3 zs-skeleton" />
            </div>
          ))}
        </div>
      )}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {getCategoryProfile?.data?.result?.length > 0 &&
          getCategoryProfile?.data?.result?.map((survey, i) => {
            const completion = getCompletion(survey);
            return (
              //Card Box
              <a
                key={i}
                href={"my-profile-category-question?category=" + survey.id}
                className="flex flex-col h-full p-5 group zs-card zs-card-interactive"
              >
                <div className="flex items-start justify-between gap-3">
                  <span className="inline-flex items-center justify-center rounded-lg w-11 h-11 shrink-0 bg-primary-soft">
                    <img src={survey.imageUrl} alt="" className="object-contain w-6 h-6" />
                  </span>
                  <div className="w-14 h-14 shrink-0">
                    <ProgressBar val={completion} />
                  </div>
                </div>
                <h3 className="mt-4 text-[15px] font-semibold font-display text-ink">{survey.name}</h3>
                <p className="flex-1 mt-1 text-sm leading-relaxed text-ink-3">{survey.content}</p>
                <div className="flex items-center justify-between gap-2 pt-4 mt-4 border-t border-line">
                  {completion >= 100 ? (
                    <span className="zs-badge zs-badge-success zs-badge-dot">Completed</span>
                  ) : completion > 0 ? (
                    <span className="zs-badge zs-badge-warning zs-badge-dot">In progress</span>
                  ) : (
                    <span className="zs-badge zs-badge-dot">Not started</span>
                  )}
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-text">
                    {completion >= 100 ? "Review" : completion > 0 ? "Continue" : "Start"}
                    <FiArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </a>
            );
          })}
      </div>
    </div>
  );
}
export default MyProfileComponents;
